<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-connection`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34.36 4l-.117.008a1.321 1.321 0 00-1.056.616.692.692 0 00-.042.087l-.017.037-.029.061a1.28 1.28 0 00-.04.124l-.015.052a.927.927 0 00-.025.12l-.013.09-.006.09v2.847c-5.703.846-10.137 5.658-10.348 11.588l-.292 8.165-.012.237-.02.237a7.426 7.426 0 01-5.052 6.311 8 8 0 10.699 3.969c4.419-1.219 7.85-5.047 8.333-9.882.024-.242.04-.486.05-.73l.291-8.164.013-.253A8.157 8.157 0 0133 12.2v2.514c0 .021.001.041.003.062l.018.135c.009.054.022.105.037.156l.019.062.022.062.057.123.031.062c.198.323.527.526.924.6.066.011.133.018.2.02l.05.004.171-.017c.238-.028.456-.113.64-.242l7.991-4.507c.472-.256.916-.757.825-1.234.09-.477-.353-.978-.825-1.234L35.172 4.26a1.389 1.389 0 00-.64-.243L34.36 4zM6 38a4 4 0 017.958-.58l-.157 1.57.074.007A4.002 4.002 0 016 38z"/></svg>
</template>
<script>

export default {
  name: 'IconConnection',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
